import { useQuery } from '@tanstack/react-query';

import { getCountryList } from '@entities/country/api/handlers';
import { keysToCamel } from '@shared/helpers';

export const useGetCountryList = () =>
    useQuery({
        queryKey: ['get-country-list'],
        queryFn: getCountryList,
        select: (data) => keysToCamel(data?.data),
    });
